import controller from './kform-builder-option-input-format.controller';
import template from './kform-builder-option-input-format.html';

const kformBuilderOptionInputFormatDirective = /* @ngInject */ () => ({
	restrict: 'E',
	replace: true,
	template,
	controller,
});

export default kformBuilderOptionInputFormatDirective;
